<template>
  <div>
    <div class="inp">
      <input placeholder="请输入用户名或手机号">
    </div>
    <div class="lastInput">
      <input placeholder="请输入密码" />
    </div>
    <!-- <div class="capt"> -->
      <!-- <input placeholder="请输入验证码">
      <img :src="form.data.img" alt="" @click="changeCapt" /> -->
    <!-- </div> -->
    <div class="forget">
      <div @click="handlerRegister">忘记密码</div>
      <div>|</div>
      <div @click="handleRegister">注册</div>
    </div>
    <button class="login">登&nbsp;录</button>
  </div>
</template>

<script>
import {captcha} from "@/api/common.js"
export default {
  data() {
    return {
      form:{
        data: {}
      }
    };
  },
  mounted(){
    if(window.innerWidth <= 980) {
      this.$router.push({
        path: "/login/mobile"
      });
    }
  },
  methods: {
    handlerRegister() {
      this.$router.push({
        path: "/login/find"
      });
    },
    handleRegister() {
      this.$router.push({
        path: "/login/register"
      });
    },
    // // 获取验证码
    // getCaptcha(){
    //   captcha({
    //     width:"150px",
    //     height:"47px"
    //   }).then(res=>{
    //     // console.log('res',res)
    //     this.form.data = res.data
    //   })
    // },
    // //点击更换验证码
    // changeCapt(){
    //   this.getCaptcha()
    // }
  }
};
</script>

<style lang="scss" scoped>
.inp {
  width: 100%;
  margin-bottom: 50px;
}
input {
  box-sizing: border-box;
  width: 100%;
  padding: 15px 0 15px 20px;
  border-radius: 5px;
  border: 1px solid #ccc;
  outline: none;
}
.lastInput {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
}
.forget {
  display: flex;
  justify-content: flex-end;
  font-size: 22px;
  margin-bottom: 60px;
  div {
    margin-left: 15px;
    cursor: pointer;
  }
}
.login {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  border: none;
  background-color: #41a5ef;
  color: #fff;
  border-radius: 5px;
  outline: none;
}
// .capt {
//   margin-bottom: 10px;
  
//   input {
//     width: 60%;
//   }
//   img {
//     margin-left: 20px;
//     width: 150px;
//     height: 47px;
//     vertical-align: middle;
//   }
// }
</style>


